import {css} from "@emotion/react";

import {calculateRemSize, mh, p, pr, pt} from "@pg-design/helpers-css-strings";
import {CloseIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {ConsultantBoxType} from "../../types/ConsultantBoxType";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {ConsultantBox} from "../ConsultantBox";
import {ForYouModalProgress} from "./ForYouModalProgress";
import {ForYouStepDescription} from "./ForYouStepDescription";

interface IProps {
    onModalClose: () => void;
}

export const ForYouModalHeading = (props: IProps) => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const {step, isLoading} = modalState;

    const renderHeading = () => {
        switch (step) {
            case ForYouModalStep.SUMMARY:
                return (
                    <div css={summaryHeading}>
                        <div css={summaryClose}>{closeButton(props.onModalClose)}</div>

                        <div css={summaryTexts}>
                            <Text variant="headline_3" as="p" align="center" className="summary-headline">
                                Dziękujemy za Twoje zgłoszenie
                            </Text>

                            <Text variant="body_copy_1" align="center">
                                Nasz konsultant skontaktuje się z Tobą w przeciągu 48 godzin, aby dopytać o szczegóły i przedstawić pierwsze propozycje
                                mieszkań.
                            </Text>
                        </div>
                    </div>
                );
            case ForYouModalStep.ADDITIONAL:
                return (
                    <div css={additionalHeading}>
                        <div css={movingClose}>{closeButton(props.onModalClose)}</div>
                        {dialogComponent()}
                    </div>
                );
            case ForYouModalStep.SUCCESS:
                return isLoading ? (
                    <div css={baseHeading}>{progressComponent(props.onModalClose)}</div>
                ) : (
                    <div css={minimalHeadingStyle}>{closeButton(props.onModalClose)}</div>
                );
            default:
                return (
                    <div css={baseHeading}>
                        {progressComponent(props.onModalClose)}
                        {dialogComponent()}
                    </div>
                );
        }
    };

    return renderHeading();
};

const closeButton = (onModalClose: () => void) => <CloseIcon size="2" wrapperSize="2" wrapperColor="transparent" onClick={onModalClose} />;

const progressComponent = (onModalClose: () => void) => (
    <div css={progressWrapper}>
        <ForYouModalProgress />
        {closeButton(onModalClose)}
    </div>
);

const dialogComponent = () => (
    <div css={consultantDialog}>
        <ForYouStepDescription />
        <ConsultantBox type={ConsultantBoxType.PHONE} />
    </div>
);

const placeOnEnd = css`
    display: flex;
    justify-content: end;
`;

const movingClose = css`
    ${placeOnEnd};

    @media (min-width: ${getThemeBreakpoint().md}) {
        position: absolute;
        top: ${calculateRemSize(3.5)};
        right: ${calculateRemSize(3.5)};
    }
`;

const summaryClose = css`
    cursor: pointer;
    position: absolute;
    top: ${calculateRemSize(3)};
    right: ${calculateRemSize(3)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        position: absolute;
        top: ${calculateRemSize(3.5)};
        right: ${calculateRemSize(3.5)};
    }
`;

const minimalHeadingStyle = css`
    ${placeOnEnd};
    margin-left: -${calculateRemSize(2)};
    ${p(1.5)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${pt(3)};
        ${pr(4)};
    }
`;

const headingStyle = css`
    display: flex;
    flex-direction: column;
    margin-left: -${calculateRemSize(2)};
    background-color: ${getThemeVariable("colors.gray.100")};
    ${p(1.5)};
`;

const baseHeading = css`
    ${headingStyle};
    gap: ${calculateRemSize(3)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(3, 4, 4, 4)};
    }
`;

const additionalHeading = css`
    ${headingStyle};
    gap: ${calculateRemSize(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(2, 9, 4, 4)};
    }
`;

const summaryHeading = css`
    background-color: ${getThemeVariable("colors.gray.100")};
    margin-left: -${calculateRemSize(2)};
    ${p(3.5, 2, 2, 2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(5, 12)};
    }
`;

const summaryTexts = css`
    display: flex;
    flex-direction: column;
    gap: ${calculateRemSize(3)};
    justify-content: center;
    align-items: center;

    .summary-headline {
        ${mh(5)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            margin: unset;
        }
    }
`;

const progressWrapper = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${calculateRemSize(2)};
`;

const consultantDialog = css`
    display: flex;
    flex-direction: row;
    gap: ${calculateRemSize(1)};

    .consultant-box {
        background-color: #fff;
        flex-direction: column;
        justify-content: center;
        min-width: 124px;
        p {
            text-align: center;
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        gap: ${calculateRemSize(3)};

        .consultant-box {
            flex-direction: row;
            justify-content: start;
            min-width: 234px;
            p {
                text-align: start;
            }
        }
    }
`;
import {css} from "@emotion/react";

import {calculateRemSize, mh, p, pr, pt} from "@pg-design/helpers-css-strings";
import {CloseIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {ConsultantBoxType} from "../../types/ConsultantBoxType";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {ConsultantBox} from "../ConsultantBox";
import {ForYouModalProgress} from "./ForYouModalProgress";
import {ForYouStepDescription} from "./ForYouStepDescription";

interface IProps {
    onModalClose: () => void;
}

export const ForYouModalHeading = (props: IProps) => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const {step, isLoading} = modalState;

    const renderHeading = () => {
        switch (step) {
            case ForYouModalStep.SUMMARY:
                return (
                    <div css={summaryHeading}>
                        <div css={summaryClose}>{closeButton(props.onModalClose)}</div>

                        <div css={summaryTexts}>
                            <Text variant="headline_3" as="p" align="center" className="summary-headline">
                                Dziękujemy za Twoje zgłoszenie
                            </Text>

                            <Text variant="body_copy_1" align="center">
                                Nasz konsultant skontaktuje się z Tobą w przeciągu 48 godzin, aby dopytać o szczegóły i przedstawić pierwsze propozycje
                                mieszkań.
                            </Text>
                        </div>
                    </div>
                );
            case ForYouModalStep.ADDITIONAL:
                return (
                    <div css={additionalHeading}>
                        <div css={movingClose}>{closeButton(props.onModalClose)}</div>
                        {dialogComponent()}
                    </div>
                );
            case ForYouModalStep.SUCCESS:
                return isLoading ? (
                    <div css={baseHeading}>{progressComponent(props.onModalClose)}</div>
                ) : (
                    <div css={minimalHeadingStyle}>{closeButton(props.onModalClose)}</div>
                );
            default:
                return (
                    <div css={baseHeading}>
                        {progressComponent(props.onModalClose)}
                        {dialogComponent()}
                    </div>
                );
        }
    };

    return renderHeading();
};

const closeButton = (onModalClose: () => void) => <CloseIcon size="2" wrapperSize="2" wrapperColor="transparent" onClick={onModalClose} />;

const progressComponent = (onModalClose: () => void) => (
    <div css={progressWrapper}>
        <ForYouModalProgress />
        {closeButton(onModalClose)}
    </div>
);

const dialogComponent = () => (
    <div css={consultantDialog}>
        <ForYouStepDescription />
        <ConsultantBox type={ConsultantBoxType.PHONE} />
    </div>
);

const placeOnEnd = css`
    display: flex;
    justify-content: end;
`;

const movingClose = css`
    ${placeOnEnd};

    @media (min-width: ${getThemeBreakpoint().md}) {
        position: absolute;
        top: ${calculateRemSize(3.5)};
        right: ${calculateRemSize(3.5)};
    }
`;

const summaryClose = css`
    cursor: pointer;
    position: absolute;
    top: ${calculateRemSize(3)};
    right: ${calculateRemSize(3)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        position: absolute;
        top: ${calculateRemSize(3.5)};
        right: ${calculateRemSize(3.5)};
    }
`;

const minimalHeadingStyle = css`
    ${placeOnEnd};
    margin-left: -${calculateRemSize(2)};
    ${p(1.5)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${pt(3)};
        ${pr(4)};
    }
`;

const headingStyle = css`
    display: flex;
    flex-direction: column;
    margin-left: -${calculateRemSize(2)};
    background-color: ${getThemeVariable("colors.gray.100")};
    ${p(1.5)};
`;

const baseHeading = css`
    ${headingStyle};
    gap: ${calculateRemSize(3)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(3, 4, 4, 4)};
    }
`;

const additionalHeading = css`
    ${headingStyle};
    gap: ${calculateRemSize(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(2, 9, 4, 4)};
    }
`;

const summaryHeading = css`
    background-color: ${getThemeVariable("colors.gray.100")};
    margin-left: -${calculateRemSize(2)};
    ${p(3.5, 2, 2, 2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(5, 12)};
    }
`;

const summaryTexts = css`
    display: flex;
    flex-direction: column;
    gap: ${calculateRemSize(3)};
    justify-content: center;
    align-items: center;

    .summary-headline {
        ${mh(5)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            margin: unset;
        }
    }
`;

const progressWrapper = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${calculateRemSize(2)};
`;

const consultantDialog = css`
    display: flex;
    flex-direction: row;
    gap: ${calculateRemSize(1)};

    .consultant-box {
        background-color: #fff;
        flex-direction: column;
        justify-content: center;
        min-width: 124px;
        p {
            text-align: center;
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        gap: ${calculateRemSize(3)};

        .consultant-box {
            flex-direction: row;
            justify-content: start;
            min-width: 234px;
            p {
                text-align: start;
            }
        }
    }
`;
